import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../../App";
import { toast } from "sonner";
import { Lock, ArrowRight, Loader2 } from "lucide-react";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      const response = await axios.post(`${API}/admin/login`, { email, password });
      
      if (response.data.status === "success") {
        sessionStorage.setItem("admin_token", response.data.token);
        sessionStorage.setItem("admin_email", response.data.email);
        toast.success("Connexion réussie");
        navigate("/admin/dashboard");
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || "Email ou mot de passe incorrect");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F7F2] flex items-center justify-center px-6">
      <div className="max-w-md w-full animate-fade-in-up">
        <div className="text-center mb-8">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-[#C5A059]/10 flex items-center justify-center">
            <Lock className="w-8 h-8 text-[#C5A059]" strokeWidth={1.5} />
          </div>
          <h1 className="font-serif text-3xl text-[#3F2A24] mb-2">
            Espace Admin
          </h1>
          <p className="text-[#4B3329]">
            Gestion du Cocon Sacré
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-wide text-[#8C6A4A] mb-2">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@coconsacre.com"
              className="input-sacred"
              required
              data-testid="admin-email-input"
            />
          </div>

          <div>
            <label className="block text-xs uppercase tracking-wide text-[#8C6A4A] mb-2">
              Mot de passe
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="input-sacred"
              required
              data-testid="admin-password-input"
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="btn-sacred w-full flex items-center justify-center gap-2 mt-6"
            data-testid="admin-login-btn"
          >
            {isLoading ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <>
                <span>Accéder</span>
                <ArrowRight className="w-4 h-4" />
              </>
            )}
          </button>
        </form>

        <div className="mt-8 text-center">
          <a 
            href="/" 
            className="text-sm text-[#8C6A4A] hover:text-[#C5A059] transition-colors"
          >
            Retour à l'accueil
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
